// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_yPR","cls2":"AuthorHeader-cls2__HV AuthorHeader-cls1_yPR"};